<asw-find-more-flights-pres
  *ngIf="!isLoading && this.findMoreFlightsResponse"
  [props]="this.props"
  [moreFlightsBoundReference]="this.moreFlightsBoundReference"
></asw-find-more-flights-pres>
